import { MatPaginatorIntl } from "@angular/material/paginator";
import {Inject, Injectable} from "@angular/core";
import {L10N_CONFIG, L10N_LOCALE, L10nConfig, L10nLocale, L10nTranslationService} from "angular-l10n";

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
	itemsPerPageLabel = '';
	nextPageLabel     = '';
	previousPageLabel = '';
	firstPageLabel    = '';
	lastPageLabel     = '';

	constructor(
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService
	) {
		super();

		this.setTranslations();
		// this.translation.translationChanged().subscribe(() => {
		// 	this.setTranslations();
		// });
	}

	getRangeLabel = function (page, pageSize, length) {
		if (length === 0 || pageSize === 0) {
			return '0 od ' + length;
		}
		length = Math.max(length, 0);
		const startIndex = page * pageSize;
		// If the start index exceeds the list length, do not try and fix the end index to the end.
		const endIndex = startIndex < length ?
			Math.min(startIndex + pageSize, length) :
			startIndex + pageSize;
//    return startIndex + 1 + ' - ' + endIndex + ' / ' + length;
		return this.translation.translate('allgemein.blättern.xbisyvonz', { "von": startIndex + 1, "bis": endIndex, "insgesamt": length});
	};

	setTranslations() {
		this.itemsPerPageLabel = this.translation.translate('allgemein.blättern.zeilenproseite');
		this.nextPageLabel = this.translation.translate('allgemein.blättern.nächsteseite');
		this.previousPageLabel = this.translation.translate('allgemein.blättern.vorigeseite');
		this.firstPageLabel = this.translation.translate('allgemein.blättern.ersteseite');
		this.lastPageLabel = this.translation.translate('allgemein.blättern.letzteseite');
	}
}
